import type { SVGProps } from "react";
import * as React from "react";

export const ArrowDropdownSmallIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12 13.5-3-3h6z"
    />
  </svg>
);
